import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import { Form } from 'react-bootstrap'
import { validateDate, validateEntity, validateContact, isContactEmpty, isEntityChildEmpty } from '../../../util/validationFunctions'
import { asyncValidateEntityDni, getFieldsValidated } from '../../../util/validationFunctionEntityDniAsync'
import { validationCreateNewFleetModalPromisesOrder } from '../../../constants/validatedFields/backValidationPromisesOrder'
import promisesStatus from '../../../constants/promisesStatus'
import { permissions } from '../../../constants/backendIds'
import { getSectionPermissions, getFieldsSectionPermissions } from '../../../util/permisionFunctions'
import { sectionPermissions } from '../../../constants/dossier/common/buttonsHeader'
import permissionCodes from '../../../constants/permissionCodes'
import { dossierTypesId } from '../../../constants/dossier/common/dossierTypes'
import { compareObjects, convertStringToDate } from '../../../util/utils'
import FleetsBasicInfo from './common/FleetsBasicInfo'
import FleetsHeader from './common/FleetsHeader'
import FleetsTab from './common/FleetsTab'

class Fleets extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      organizedUnitId: null,
      fields: {},
      haveChanges: false,
      fieldsConfiguration: {
        createFleet: { permission: null },
        editFleet: { permission: null },
        operateFleet: { permission: null },
        economicFleet: { permission: null },
        documentsFleet: { permission: null },
        viewFleet: { permission: null },
        deleteFleet: { permission: null },
        codeCommission: { permission: null },
        addOtherDocumentsFleet: { permission: null }
      }
    }
    this.goBack = this.goBack.bind(this)
    this.handleSubmitForm = this.handleSubmitForm.bind(this)
  }

  componentDidMount () {
    if (this.props.match.params.fleetId && this.props.match.params.fleetId !== '-1') {
      this.getFleetModel()
      this.props.actions.getDossierHistoricalsFleet(this.props.match.params.fleetId)
    } else {
      this.props.actions.openCreateEditFleetModal(true)
    }

    this.props.actions.fetchIaeCombo()
    if (this.props.match.params.fleetId === '-1') {
      this.props.actions.fetchOrganizedUnitsTreeComboByPermission(permissionCodes.createFleetManagement)
    } else {
      this.props.actions.fetchOrganizedUnitsCombo()
    }
    this.props.actions.fetchOrganizedUnitsAcceptClientsCombo()
    this.props.actions.fetchEntityTypes()
    this.props.actions.fetchDossierTypes()
    this.initializePermisions(this.props)

    if (!this.props.combos.dossierSubTypesCombo || this.props.combos.dossierSubTypesCombo?.length === 0) {
      this.props.actions.fetchDossierSubTypes(null, dossierTypesId.sales)
    }
  }

  componentDidUpdate (prevProps) {
    const prevFleetId = prevProps.match.params.fleetId
    const currentFleetId = this.props.match.params.fleetId

    if ((prevFleetId !== currentFleetId && this.props.match.params.fleetId !== '-1') || (this.props.match.params.fleetId !== '-1' && prevProps.dossierFleetDetails !== this.props.dossierFleetDetails && this.props.fleetData.fleet && this.props.dossierFleetDetails.length !== this.props.fleetData.fleet?.numDossiers)) {
      this.getFleetModel()
      this.props.actions.fetchOrganizedUnitsCombo()
      this.setState({ haveChanges: false })
    }
  }

  initializePermisions (props) {
    const section = props.sectionsGeneral.filter((tabConf) => tabConf.code === sectionPermissions.management)
    if (section.length > 0 && section[0] != null) {
      const newState = getSectionPermissions(section[0])
      let permissionState = this.state.sectionTabsConfiguration
      permissionState = { ...permissionState, ...newState }
      if (permissionState.fleet_management_section && permissionState.fleet_management_section.sectionFieldsConfiguration) {
        const fieldKeys = Object.keys(this.state.fieldsConfiguration)
        const permission = getFieldsSectionPermissions(permissionState.fleet_management_section.sectionFieldsConfiguration, fieldKeys, permissions.hidden)
        this.setState({ fieldsConfiguration: permission.fieldsConfiguration })
      }
    }
  }

  goBack () {
    this.props.history.goBack()
    this.props.actions.closeCreateEditFleetModal()
    this.props.actions.closeOperateFleetModal()
    this.props.reset()
  }

  handleSubmitForm (e) {
    this.props.handleSubmit((values) => this.createOrUpdateFleet(values))()
  }

  createOrUpdateFleet (values) {
    let fleet = {}
    fleet.FleetCode = values.fleetCode
    fleet.Description = values.description
    fleet.Observations = values.observations
    fleet.EntityComponent = values.entityComponent ?? this.props.fleetData?.entityComponent
    fleet.OrganizedUnitId = values.organizedUnitId
    fleet.DossierSubType = values.dossierSubType
    fleet.RenewalDate = values.renewalDate
    fleet.FinalEntity = values.entityChildComponent ?? this.props.fleetData?.finalEntity
    fleet.DossierContactComponent = values.dossierContactComponent ?? this.props.fleetData?.dossierContactComponent
    if (this.props.match.params.fleetId === '-1') {
      this.createFleet(fleet)
    } else {
      this.updateFleet(fleet)
    }
  }

  createFleet (fleetModel) {
    new Promise((resolve, reject) => {
      this.props.actions.createUpdateFleet(fleetModel, resolve, reject, this.props.fleetData.fleet)
    }).then((response) => {
      this.props.history.replace(`/fleet/${response.fleetId}`)
    }).catch((error) => {
      this.props.actions.openModal('actionAdminFleetExpFleetError', null, null, null, null, error.json?.tag ? error.json.tag : null)
    })
  }

  updateFleet (fleetModel) {
    fleetModel.fleetId = this.props.fleetData.fleet.fleetId
    if (!this.compareToSave(fleetModel)) {
      new Promise((resolve, reject) => {
        this.props.actions.createUpdateFleet(fleetModel, resolve, reject, this.props.fleetData.fleet)
      }).then((response) => {
        if (response) {
          this.props.actions.openModal('fleetModified', () => { this.setState({ haveChanges: false }) }, null, null, null, [{ id: '##FLEET_CODE##', value: response.fleetCode }, { id: '##DESCRIPTION##', value: response.description }], null)
          this.getFleetModel()
          this.props.actions.fetchOrganizedUnitsCombo()
          this.setState({ haveChanges: false })
        }
      }).catch(() => {
        if (this.props.fleetData.fleet.numDossiers <= 0) {
          this.props.actions.openModal('actionAdminFleetExpFleetError')
        }
      })
    } else {
      this.props.actions.openModal('notChangesToSave')
    }
  }

  compareToSave (fleetModel) {
    let fleet = {}
    fleet.FleetCode = this.props.fleetData.fleet.fleetCode
    fleet.Description = this.props.fleetData.fleet.description
    fleet.Observations = this.props.fleetData.fleet.observations
    fleet.EntityComponent = this.props.fleetData.fleet.entityComponent
    fleet.OrganizedUnitId = this.props.fleetData.fleet.organizedUnitId
    fleet.DossierSubType = this.props.fleetData.fleet.dossierSubType
    fleet.RenewalDate = this.props.fleetData.fleet.renewalDate
    fleet.FinalEntity = this.props.fleetData.fleet.finalEntity
    fleet.DossierContactComponent = this.props.fleetData.fleet.dossierContactComponent
    fleet.fleetId = this.props.fleetData.fleet.fleetId

    return compareObjects(fleet, fleetModel, true)
  }

  getFleetModel () {
    new Promise((resolve) => {
      this.props.actions.getFleetModel(this.props.match.params.fleetId, resolve)
    }).then((response) => {
      response.entityChildComponent = response.finalEntity
      this.props.initialize(response)
      this.props.actions.openCreateEditFleetModal(false, response)
      this.getClientPermissions(response?.organizedUnitId)
    })
  }

  organizedUnitChange (value) {
    this.fieldFill({ organizedUnitId: value })
    this.getClientPermissions(value)
  }

  getClientPermissions (organizedUnitId) {
    if (organizedUnitId) {
      this.props.actions.getClientFleetPermissions(null, organizedUnitId, 1)
    } else if (this.state.organizedUnit && this.state.organizedUnit !== null) {
      this.props.actions.getClientFleetPermissions(null, this.state.organizedUnitId, 1)
    }
  }

  fieldFill (field) {
    this.setState({ fields: { ...this.state.fields, ...field } })
  }

  stateFill (field) {
    this.setState({ ...this.state, ...field })
  }

  tabActiveKeyChange (key) {
    this.props.actions.setActiveFleetTab(key)
  }

  validateDate (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  render () {
    const {
      t, clientFleetPermissions, dispatch, fleetData, change, formValues, dirty, reset,
      actions: {
        openModal,
        setDeleteFleetProcess,
        stopAsyncValidation,
        fetchIaeCombo,
        fetchOrganizedUnitsTreeComboByPermission,
        fetchOrganizedUnitsCombo,
        fetchOrganizedUnitsAcceptClientsCombo,
        fetchEntityTypes
      },
      combos: { dossierSubTypesCombo, UOTreeCombo, UOTreeComboByPermission }
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'

    return (
      <>
        <Form id="fleets" autoComplete="off">
          <div className="dossierGrid" id="fleets_DossierGrid">
            <div className="dossierGridPart-header" id="fleets_FleetHeaderPart">
              <FleetsHeader
                t={t}
                fleetData={fleetData}
                fleetId={this.props.match.params.fleetId}
                tKey={tKey}
                fieldsConfiguration={this.state.fieldsConfiguration}
                haveChanges={this.state.haveChanges}
                dirty={dirty}
                reset={reset}
                actions={{
                  openModal,
                  setDeleteFleetProcess,
                  fieldFill: (field) => this.fieldFill(field),
                  stateFill: (field) => this.stateFill(field),
                  goBack: this.goBack,
                  handleSubmitForm: this.handleSubmitForm
                }}
              />
            </div>
            <div className="dossierGridPart-body" id="fleets_FleetBodyInfoPart">
              <FleetsBasicInfo
                t={t}
                isReadOnly={this.state.fieldsConfiguration.editFleet.permission !== permissions.editable}
                fleetData={fleetData}
                fleetId={this.props.match.params.fleetId}
                tKey={tKey}
                haveChanges={this.state.haveChanges}
                combos={{
                  dossierSubTypesCombo,
                  UOTreeCombo,
                  UOTreeComboByPermission
                }}
                actions={{
                  organizedUnitChange: (val) => this.organizedUnitChange(val),
                  fieldFill: (field) => this.fieldFill(field),
                  stateFill: (field) => this.stateFill(field),
                  fetchIaeCombo,
                  fetchOrganizedUnitsTreeComboByPermission,
                  fetchOrganizedUnitsCombo,
                  fetchOrganizedUnitsAcceptClientsCombo,
                  fetchEntityTypes
                }}
              />
            </div>
            <div className="ComponentSection-InnerMennu" id="fleets_FleetTabsPart">
              <FleetsTab
                t={t}
                isReadOnly={this.state.fieldsConfiguration.editFleet.permission !== permissions.editable}
                fleetData={fleetData}
                fleetId={this.props.match.params.fleetId}
                dossierFleetDetails={this.props.dossierFleetDetails}
                purchaseFleetDetails={this.props.purchaseFleetDetails}
                tKey={tKey}
                change={change}
                combos={this.props.combos}
                formValues={formValues}
                dispatch={dispatch}
                stopAsyncValidation={(value) => stopAsyncValidation('createNewFleetModal', value)}
                asyncValidateFunc={asyncValidate}
                clientFleetPermissions={clientFleetPermissions}
                fields={this.state.fields}
                fieldsConfiguration={this.state.fieldsConfiguration}
                haveChanges={this.state.haveChanges}
                dirty={dirty}
                operationActions={this.props.operationActions}
                dataActions={this.props.dataActions}
                dataPaperWorkActions={this.props.dataPaperWorkActions}
                operationPaperWorkActions={this.props.operationPaperWorkActions}
                dataPurchaseActions={this.props.dataPurchaseActions}
                operationPurchaseActions={this.props.operationPurchaseActions}
                componentsModalConfiguration={this.props.componentsModalConfiguration}
                reset={reset}
                deliveryFleetDetails={this.props.deliveryFleetDetails}
                dossierHistoricalFleetDetails={this.props.dossierHistoricalFleetDetails}
                tabActiveKey={fleetData?.tabActiveKey}
                tabActiveKeyChange={(key) => this.tabActiveKeyChange(key)}
                actions={{
                  ...this.props.actions,
                  fieldFill: (field) => this.fieldFill(field),
                  stateFill: (field) => this.stateFill(field)
                }}
              />
            </div>
          </div>
        </Form>
      </>
    )
  }
}

const validate = (values, props) => {
  const errors = {}

  if (!values || !values.organizedUnitId) {
    errors.organizedUnitId = props.t('GLOBAL.FORMS.REQUIRED')
  }
  if (!values || !values.fleetCode) {
    errors.fleetCode = props.t('GLOBAL.FORMS.REQUIRED')
  }
  if (!values || !values.description) {
    errors.description = props.t('GLOBAL.FORMS.REQUIRED')
  }
  if (!values || !values.dossierSubType) {
    errors.dossierSubType = props.t('GLOBAL.FORMS.REQUIRED')
  }

  if (values && values.renewalDate) {
    if (!props.fleet || (props.fleet.renewalDate !== values.renewalDate)) {
      let renewalDate = convertStringToDate(values.renewalDate)

      if (Date.now() > renewalDate) {
        errors.renewalDate = props.t('GLOBAL.FORMS.DATE_INVALID_GREATER_THAN_CURRENT_DATE')
      }
    }
  }
  errors.entityComponent = validateEntity(values.entityComponent, props)
  if (props.registeredFields) {
    const entityChildHasData = values.entityChildComponent ? !isEntityChildEmpty(values.entityChildComponent, props.registeredFields) : false
    if (entityChildHasData) {
      errors.entityChildComponent = validateEntity(values.entityChildComponent, props, null, true)
    }

    const contactHasData = values.dossierContactComponent ? !isContactEmpty(values.dossierContactComponent, props.registeredFields) : false

    if (contactHasData) {
      errors.dossierContactComponent = validateContact(values.dossierContactComponent, props)
    }
  }

  return errors
}

const asyncValidate = (values, dispatch, props, field, returnError) => {
  let promises = []
  if (values.entityComponent) {
    promises = promises.concat(asyncValidateEntityDni(values.entityComponent, dispatch, props, props.fleet?.organizedUnitId ?? values.organizedUnitId))
    promises = promises.concat(asyncValidateEntityDni(values.entityChildComponent, dispatch, props, props.fleet?.organizedUnitId ?? values.organizedUnitId))
  }

  return Promise.allSettled(promises).then(result => {
    let error = {}
    for (let index = 0; index < result.length; index++) {
      const element = result[index]
      if (element.status === promisesStatus.FULFILLED) {
        switch (index) {
          case validationCreateNewFleetModalPromisesOrder.ENTITY_COMPONENT:
            error = { ...error, entityComponent: element.value }
            break
          case validationCreateNewFleetModalPromisesOrder.ENTITY_CHILD_COMPONENT:
            error = { ...error, entityChildComponent: element.value }
            break
          default:
            break
        }
      }
    }
    if (Object.keys(error).length > 0 && !returnError) throw Object.assign(new Error(), error)
    if (returnError) return error
  })
}

export default reduxForm({
  form: 'fleets',
  validate,
  asyncValidate,
  asyncBlurFields: [...getFieldsValidated('entityComponent'), ...getFieldsValidated('entityChildComponent')]
})(Fleets)
